import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageHeaderWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageHeader__PrimaryMessageHeaderWrapper",
  componentId: "bj0bt3-0"
})(["display:flex;height:16px;align-items:center;margin-top:4px;margin-bottom:4px;width:100%;"]);
export default class PrimaryMessageHeader extends PureComponent {
  render() {
    const {
      children,
      className
    } = this.props;
    return /*#__PURE__*/_jsx(PrimaryMessageHeaderWrapper, {
      className: className,
      "data-test-id": "primary-message-header-wrapper",
      children: children
    });
  }
}
PrimaryMessageHeader.displayName = 'PrimaryMessageHeader';
PrimaryMessageHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};